import baseURL from "../Api/baseURL";
const loggedUser = JSON.parse(localStorage.getItem("user"));

let token;
if (loggedUser?.token) {
  token = loggedUser?.token;
}

export const useInsertData = async (url, params) => {
  let configInsert = {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : { is_admin: true }),
    },
  };
  const res = await baseURL.post(url, params, configInsert);
  return res.data;
};

export const useInsertDataWithImage = async (url, params) => {
  let configInsert = {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(token ? { Authorization: `Bearer ${token}` } : { is_admin: true }),
    },
  };
  const res = await baseURL.post(url, params, configInsert);
  return res;
};
